module.exports = __webpack_public_path__ + "public/images/SunBackground.731aad054eef60780ef3524c9286732c.svg";